import React, { createContext, useState, useContext, useEffect } from 'react';
import { fetchFundingRounds } from '../utils/openfund-api';

// Create context
const FundingRoundContext = createContext();

// Export the use context hook for easy consumption
export const useFundingRound = () => useContext(FundingRoundContext);

// Provider component
export const FundingRoundProvider = ({ children }) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const username = "FOCUS_reservations"; // Example username, adjust as needed

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            const fundingRounds = await fetchFundingRounds(username);
            setIsLoading(false);
            if (fundingRounds && fundingRounds.length > 0) {
                setData(fundingRounds[0]);
            }
        };
        loadData();
    }, [username]);

    return (
        <FundingRoundContext.Provider value={{ data, isLoading }}>
            {children}
        </FundingRoundContext.Provider>
    );
};
